// Día en curso dentro de las estadísticas.
//
// El desktop publica el documento `daily_{hoy}` mientras el día transcurre, así
// que los totales y los gráficos reflejan lo que va pasando. Pero ese día es
// PARCIAL: contarlo como uno completo distorsiona promedios, proyecciones y el
// "mejor día", que compararían medio día contra días enteros.
//
// Regla: los TOTALES y los GRÁFICOS incluyen hoy (es lo que el dueño espera
// ver); los CÁLCULOS DERIVADOS lo excluyen.

import moment from "moment";

export const hoyISO = () => moment().format("YYYY-MM-DD");

/** ¿Este documento diario corresponde al día en curso? */
export const esDiaEnCurso = (doc) => !!doc && doc.date === hoyISO();

/** Los mismos documentos sin el día en curso. Para promedios y proyecciones. */
export const sinDiaEnCurso = (docs) =>
  (docs || []).filter((d) => !esDiaEnCurso(d));
